import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import NotificationModifyingHeader from "./notificationModifyingHeader";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {ACTIVITY_TYPE} from "../../../common/Constants";
import * as R from "ramda";
import {tableConfigListCustomer} from "../config";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import {fetchDataAsync} from "../../../../Services/Utils";
import {mapToObjectDDL} from "../../../common/mapper";
import NotificationUploadCustomer from "./notificationUploadCustomer";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class NotificationModifying extends Component {
    checkButton = [
        {
            name: "memberId",
            label: "Check/Uncheck",
            options: {
                setCellProps: () => ({style: {width: "150px"}}),
                customBodyRender: (val) => {
                    const checked = this.checkListCustomer(val);
                    return (
                        <FlexView style={{width: "100px", justifyContent: "center"}}>
                            <SimpleCheckBox
                                id={`check_${val}`}
                                checked={checked}
                                onChange={() => this.handleCheck(val)}
                            />
                        </FlexView>
                    );
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: false,
            tableConfig: [],
            rawDataTable: [],
            dataTable: [],
            selectedCustomer: [],
            categoryOptions: [],
            customerName: "",
            uploadVisible: false,
            zeroCustomer: false,
            pagination: {
                limit: 10,
                page: 1,
                totalData: 0
            }
        };
    };

    componentDidMount = async () => {
        if (!R.isNil(this.props.initialValues)) {
            let dataCustomerRaw = this.props.initialValues?.dataCustomerRaw;
            let dataCustomer = this.props.controls.dataCustomer?.value;
            let selectedCustomer = dataCustomer.filter(item => item.checked === true).map(item => item.memberId);
            let isSimilar = dataCustomerRaw.length === selectedCustomer.length
                && dataCustomerRaw.every(item => selectedCustomer.includes(item.memberId));
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: this.props.controls.dataCustomer?.value,
                rawDataTable: this.props.initialValues?.dataCustomerRaw,
                selectedCustomer: selectedCustomer,
                isAllSelected: isSimilar,
            }));
        }
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: (this.props.activityType === ACTIVITY_TYPE.VIEW || this.state.isAllSelected)
                ? [...tableConfigListCustomer]
                : [...this.checkButton, ...tableConfigListCustomer],
        }));
        await this.fetchCategoryNotification();
    };

    fetchCategoryNotification = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
            menuName: "Management Notification",
            setError: this.props.setError,
            args: {paramFilters: {bizparCategory: "NOTIF_CATEGORY"}}
        });
        if (res.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                categoryOptions: res.data.data.map(item => mapToObjectDDL(item.value, item.key))
            }));
        }
    };

    handleCheck = (customerId) => {
        let {dataCustomerRaw} = this.props.initialValues;
        let selectedCustomer = this.state.selectedCustomer.includes(customerId)
            ? this.state.selectedCustomer.filter(item => item !== customerId)
            : [...this.state.selectedCustomer, customerId];
        let isSimilar = dataCustomerRaw.length === selectedCustomer.length
            && dataCustomerRaw.every(item => selectedCustomer.includes(item.memberId));
        this.setState((prevValue) => ({
            ...prevValue,
            selectedCustomer: selectedCustomer,
            isAllSelected: isSimilar,
        }));
    };

    checkListCustomer = (id) => {
        return this.state.selectedCustomer.includes(id);
    };

    handleSelectAll = (e) => {
        const isChecked = e.target.checked;

        this.setState((prevValue) => ({
            ...prevValue,
            isAllSelected: isChecked,
            selectedCustomer: isChecked ? this.state.dataTable.map(item => item.memberId) : [],
        }));
    };

    handleSave = () => {
        if (this.props.validate() && this.state.selectedCustomer.length > 0) {
            this.props.onSubmit(this.props.controls, "save", this.state.selectedCustomer);
        }
        if (this.state.selectedCustomer.length === 0) {
            this.handleZeroCustomer();
        }
    };

    handleSend = () => {
        if (this.props.validate() && this.state.selectedCustomer.length > 0) {
            this.props.onSubmit(this.props.controls, "send", this.state.selectedCustomer);
        }
        if (this.state.selectedCustomer.length === 0) {
            this.handleZeroCustomer();
        }
    };

    handleZeroCustomer = () => {
        this.setState((prevValue) => ({...prevValue, zeroCustomer: !prevValue.zeroCustomer}));
    };

    filterCustomer = () => {
        let dataCustomer = this.state.rawDataTable.filter(
            item => item?.namaCustomer?.toLowerCase().includes(this.state.customerName.toLowerCase())
                || item?.memberId?.toLowerCase().includes(this.state.customerName.toLowerCase())
        );
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: dataCustomer,
        }));
    };

    onChangeNameCustomer = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            customerName: value,
        }));
    };

    handleUploadVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            uploadVisible: !prevValue.uploadVisible,
        }));
    };

    handleAddCustomer = (listCustomer) => {
        let toAdd = R.difference(listCustomer, this.state.selectedCustomer);
        this.setState((prevValue) => ({
            ...prevValue,
            selectedCustomer: [...this.state.selectedCustomer, ...toAdd],
        }));
    };

    customSort = (data, colIndex, order) => {
        return data.sort((a, b) => {
            let val1 = this.state.selectedCustomer.includes(a.data[2]) ? 1 : 0;
            let val2 = this.state.selectedCustomer.includes(b.data[2]) ? 1 : 0;
            return (val1 - val2) * (order === "asc" ? 1 : -1);
        });
    }

    handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: tableState.page + 1,
        },
      }));
    };

    handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: 1,
          limit: tableState.rowsPerPage,
        },
      }));
    };

    render() {
        return (
            <SimpleModal
                title="Form Message"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <NotificationModifyingHeader
                            {...this.props}
                            categoryOptions={this.state.categoryOptions}
                        />
                        <FlexView column style={{marginBottom: "20px"}}>
                            <SimpleCheckBox
                                id="selectAllCustomer"
                                key="selectAllCustomer"
                                name="isAllSelected"
                                label="Kirim ke Semua Pelanggan"
                                checked={this.state.isAllSelected}
                                onChange={(e) => this.handleSelectAll(e)}
                                disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                            />
                            <FlexView style={{justifyContent: "end"}}>
                                <SimpleInput
                                    name="customerName"
                                    placeholder="Member Id / Customer Name"
                                    value={this.state.customerName}
                                    onChange={({target}) => this.onChangeNameCustomer(target.value)}
                                />
                                <SimpleButton onClick={this.filterCustomer}>Cari</SimpleButton>
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.dataTable.length}-${this.state.pagination.page}`}
                                title="List Customer"
                                data={this.state.dataTable}
                                columns={this.state.tableConfig}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{
                                    ...defaultTableChange(this.handleChangePage, this.handleRowsPerPage),
                                    serverSide: false,
                                    customSort: this.customSort,
                                }}
                            />
                        </FlexView>
                        {this.props.activityType !== ACTIVITY_TYPE.VIEW && (
                            <FlexView style={{justifyContent: "end", gap: "30px"}}>
                                <SimpleButton onClick={this.handleUploadVisibility}>Upload</SimpleButton>
                                <SimpleButton onClick={this.handleSend}>Kirim</SimpleButton>
                                <SimpleButton onClick={this.handleSave}>Simpan</SimpleButton>
                            </FlexView>
                        )}
                        {this.state.uploadVisible && (
                            <NotificationUploadCustomer
                                triggerLoading={this.props.triggerLoading}
                                visible={this.state.uploadVisible}
                                onClickClose={this.handleUploadVisibility}
                                handleAddCustomer={this.handleAddCustomer}
                            />
                        )}
                        {this.state.zeroCustomer && (
                            <SimpleAlert
                                visible={this.state.zeroCustomer}
                                title="Informasi"
                                onClickClose={this.handleZeroCustomer}
                                content={
                                    <div>
                                        <FlexView hAlignContent="center" column>
                                            <p>Notifikasi Harus Memiliki Minimal</p>
                                            <p>Satu(1) Customer Dituju. Silakan</p>
                                            <p>Cek Kembali List Customer.</p>
                                            <SimpleButton onClick={this.handleZeroCustomer}>
                                                OK
                                            </SimpleButton>
                                        </FlexView>
                                    </div>
                                }
                            />
                        )}
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(NotificationModifying);